import { isEqual, pick } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import Box from 'components/Box'
import { Button } from 'components/Button'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import { InfoBox, InfoBoxItem } from 'components/InfoBox'
import ListHeader from 'components/ListHeader'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { getCdnUrl } from '../../data/api/cdn'
import { EntryProps } from '../../data/entries/types'
import { inControlOptions } from '../../data/models/funnelOrder/days'
import { Theme } from '../../data/models/funnelOrder/theme'
import {
  getSiteCountryICC2,
  getSiteCurrencyISO,
  SiteCountry,
  SiteCurrency,
} from '../../data/models/locale'
import { getClient } from '../../data/openapi'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import IfCountry from '../../elements/conditionals/IfCountry'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import AirportComponent from '../funnel/customise/options/airport'
import Days from '../funnel/customise/options/days'
import FlyExcluded from '../funnel/customise/options/flyExcluded'
import People from '../funnel/customise/options/people'
import RoomType from '../funnel/customise/options/roomType'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import Countdown from './components/countdown'
import HowItWorks from './components/entries/howItWorks'
import FAQ from './components/faq'
import FlavourBox from './components/flavourBox'

interface LastMinuteProps extends EntryProps {
  patternImage: string
  total: number
  days: number
  country: SiteCountry
  currency: SiteCurrency
  contentLoading: boolean
  onChangeDays: (days: number) => void
}

interface LastMinuteState {
  five_days: number
  seven_days: number
}

class LastMinutePage extends React.Component<
  LastMinuteProps & CustomiseWrapperInnerProps,
  LastMinuteState
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement
  constructor(props: LastMinuteProps & CustomiseWrapperInnerProps) {
    super(props)
    this.state = {
      five_days: NaN,
      seven_days: NaN,
    }
  }

  public shouldPricesUpdate(
    oldProps: LastMinuteProps & CustomiseWrapperInnerProps,
  ) {
    const keys = ['currency', 'country', 'contentLoading']

    return !isEqual(pick(oldProps, keys), pick(this.props, keys))
  }

  public componentDidUpdate(
    oldProps: LastMinuteProps & CustomiseWrapperInnerProps,
  ) {
    if (this.shouldPricesUpdate(oldProps)) {
      if (!this.props.contentLoading) {
        const { country, currency } = this.props
        const data = {
          site_country: getSiteCountryICC2(country),
          site_currency: getSiteCurrencyISO(currency),
        }
        getClient()
          .then(client => client.apis.bookings.bookings_inner_from_prices(data))
          .then(response => {
            const state = {
              five_days: response.body.five_days.price,
              seven_days: response.body.seven_days.price,
            }
            this.setState(state)
          })
      }
    }
  }

  public render() {
    const {
      entry,
      match,
      prices,
      airports,
      loading,
      currency,
      patternImage,
      days,
    } = this.props
    const pattern = getCdnUrl('Explore-New-Cities-spaghetti.png')

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
      >
        <Hero
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarColored()}
              firstLine={
                <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="1-info-bottom">
                  Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={
                entry.theme === Theme.fly
                  ? SRPRS.aeroplaneColored
                  : SRPRS.carColored
              }
              firstLine={
                <DisplayContent contentKey="2-info-top">2 tot 4</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  Steden
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '37',
                height: '37',
                viewBox: '0 0 37 41',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
          nrItems={entry.page.content ? entry.page.content.topList : undefined}
        />
        {entry.expiry ? (
          <Countdown pattern={pattern} timestamp={entry.expiry} />
        ) : null}
        <Section type={SectionType.solid} size={Size.xs}>
          <Style margin={[[0, 0, 20, 0]]}>
            <div ref={this.setDetailsRef} />
            <div className="margin-b-m">
              <ActionList>
                <People />
                <IfCountry country={SiteCountry.uk}>
                  <AirportComponent {...{ airports, noTimes: true }} />
                </IfCountry>
                <Days options={inControlOptions} />
                <RoomType />
                <FlyExcluded />
              </ActionList>
            </div>
            <Box fullWidthMobile>
              <Calendar
                actionList
                hideTrigger
                showCheapest={true}
                prices={prices}
                loading={loading}
              />
            </Box>
          </Style>
          <PersonModal />
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={isNaN(this.props.total)}
        />
        <GiftcardModal />
        <FlavourBox
          patternImage={patternImage}
          setInfoRef={this.setInfoRef}
          content={entry.page.content}
        />
        <HowItWorks />
        <Section type={SectionType.white}>
          <ListHeader noMarginBottom>
            <Button cutOff="left" onClick={this.handleDetailsScroll}>
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ nrItems={4} />
      </Page>
    )
  }

  private changeDays = (days: string) => {
    this.props.onChangeDays(+days)
  }

  private renderPrice = (price: number) => {
    return isNaN(price) ? '-' : price.toString()
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedLastMinutePage = connect(
  (state: AppState) => ({
    patternImage: state.page.patternImage,
    total: state.funnelOrder.total,
    days: state.funnelOrder.days,
    country: state.locale.country,
    currency: state.locale.currency,
    contentLoading: state.contentEngine.loading,
  }),
  dispatch => ({
    onChangeDays: (days: number) => {
      dispatch(actions.change('funnelOrder.days', days))
    },
  }),
)(LastMinutePage)

export default withAirportsAndPrices<EntryProps>(ConnectedLastMinutePage, [
  QueryKey.month,
  QueryKey.year,
])
